import {
  HIDE_CONTRACTOR_LIST_LOADER,
  SET_CONTRACTOR_PROFILE,
  SET_CONTRACTORS_LIST,
  SET_ERROR_CONTRACTOR_PROFILE,
  SHOW_CONTRACTOR_LIST_LOADER,
  CONTRACTOR_PROFILE_LOADER,
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  profileData: {},
  profileLoader: false,
  isError: false,
  loading: false,
  error: null,
};

const ContractorList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CONTRACTORS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SHOW_CONTRACTOR_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_CONTRACTOR_LIST_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_CONTRACTOR_PROFILE:
      return {
        ...state,
        profileData: action.payload,
      };
    case SET_ERROR_CONTRACTOR_PROFILE:
      return {
        ...state,
        isError: action.payload,
      };
    case CONTRACTOR_PROFILE_LOADER:
      return {
        ...state,
        profileLoader: !state.profileLoader,
      };
    default:
      return state;
  }
};

export default ContractorList;
